import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import { nextAsset } from '../../../../components/nextAsset';

export const FeaturesCustomize: React.FC = () => {
  const intl = useIntl();

  return (
    <div className="smartlinks-music-marketing py-5">
      <Container className="py-5">
        <Row>
          <Col>
            <h2 className="main-header text-center pt-5 pb-3 text-secondary">
              {intl.formatMessage({
                id: 'sml.web.smartlinks.features.customize.title',
                defaultMessage: 'Customize'
              })}
            </h2>
            <p className="main-header-subtitle text-center">
              {intl.formatMessage({
                id: 'sml.web.smartlinks.features.customize.drive-streams.title',
                defaultMessage:
                  'Select a template and customize your background, fonts, images and more. Look like a pro with minimum effort.'
              })}
            </p>
            <p className="text-center p-5">
              <img
                src={nextAsset('images/smartLinks/features/themes-example.jpg')}
                className="img-fluid"
                alt="Customize example"
              />
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
